import "core-js/modules/web.dom.iterable.js";
import { useEffect, useState } from 'react';
const useLifeCycleEventBus = function (eventName) {
  let isLifeCycle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [eventPayload, setEventPayload] = useState({});
  useEffect(() => {
    var _window$LIFE_CYCLE_EV;
    const eventHandler = payload => {
      const {
        output
      } = payload;
      setEventPayload(output);
    };
    const EVENTBUS = isLifeCycle ? (_window$LIFE_CYCLE_EV = window.LIFE_CYCLE_EVENT_BUS) === null || _window$LIFE_CYCLE_EV === void 0 ? void 0 : _window$LIFE_CYCLE_EV.lifeCycle : window.LIFE_CYCLE_EVENT_BUS;
    if (EVENTBUS) {
      EVENTBUS.on(eventName, eventHandler);
    }
  }, [eventName]);
  return eventPayload;
};
export { useLifeCycleEventBus };
//# sourceMappingURL=useLifeCycleEventBus.js.map